import { Injectable } from '@angular/core';
import { User } from '../interfaces/user';
import { Video } from '../interfaces/video/video';
import { VideoSubtitle } from '../interfaces/video/video-subtitle';
import { ApiService } from './api.service';
import { ApiV1Service } from './api.v1.service';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

import * as moment from 'moment';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class VideoService {
  user: User | null = null;
  private data = new Subject<string | void>();
  data$ = this.data;
  constructor(private api: ApiService, private apiV1: ApiV1Service, private auth: AuthService) {
    this.auth.user.subscribe((user) => {
      this.user = user;
    });
  }

  sendData() {
    this.data.next();
  }

  async getPublic(
    limit: number | null = 16,
    page: number | null = 1,
    order: string | null,
    search: string | null,
    owner: string | null,
    published: string | null = null
  ) {
    if (!order) {
      order = 'RELEVANCE';
    }

    try {
      let query = `?limit=${limit}&page=${page}&search=${search || ''}&owner=${
        owner || ''
      }`;
      if (published) {
        query += '&published=false';
      }

      const playlists = await this.api.get('/video' + query);
      return playlists;
    } catch (error) {
      return error;
    }
  }
  async getFavorites(username: string | null) {
    try {
      let query = `?username=${username || ''}`;

      const playlists = await this.api.get(
        '/user/' + username + '/favorites' + query
      );
      return playlists;
    } catch (error) {
      return error;
    }
  }

  async getVideoURL(url: string) {
    try {
     
console.log('testin!!!',environment.videoSpacesPlayer+url)
      const videoUrl = await this.apiV1.getRawURL(environment.videoSpacesPlayer+url)
   
      return videoUrl;
    } catch (error) {
      return error;
    }
  }

  // Subtítulos listos del video (keetup/video-subtitles en la API Laravel)
  async getSubtitles(videoId: number): Promise<VideoSubtitle[]> {
    try {
      const resp = await this.apiV1.getRawURL(
        `${environment.apiUrl_v1}/videos/${videoId}/subtitles`
      );
      return resp?.data ?? [];
    } catch (error) {
      return [];
    }
  }

  // Todos los subtítulos del video, también pending/processing/failed (keetup/video-subtitles
  // en la API Laravel). Si falla se devuelve null para no confundirlo con "sin subtítulos"
  async getSubtitlesStatus(videoId: number): Promise<VideoSubtitle[] | null> {
    try {
      const resp = await this.apiV1.get(`/videos/${videoId}/subtitles`, { all: 1 });
      return resp?.data ?? [];
    } catch (error) {
      return null;
    }
  }

  // Encola la generación de subtítulos de un video que no los tiene (dueño o super_user)
  generateSubtitles(videoId: number): Promise<any> {
    return this.apiV1.postJSON(`/videos/${videoId}/subtitles`, {});
  }

  async getEnrolled(
    limit: number | null = 50,
    page: number | null = 1,
    order: string | null,
    search: string | null
  ) {
    order = 'DESC';
    try {
      let query = `?type=playlist&limit=${limit}&page=${page}&search=${
        search || ''
      }&order=${order}&owner=&section=joined&joined=true`;
      const playlists = await this.api.get('/collection/enrolled' + query);
      return playlists;
    } catch (error) {
      return error;
    }
  }

  async getOwn(
    limit: number | null = 50,
    page: number | null = 1,
    order: string | null,
    search: string | null
  ) {
    order = 'DESC';
    try {
      let query = `?type=playlist&limit=${limit}&page=${page}&search=${
        search || ''
      }&order=${order}&owner=${this.user?.username}&section=joined&joined=true`;
      const playlists = await this.api.get('/collection' + query);
      return playlists;
    } catch (error) {
      return error;
    }
  }

  async getById(id: number | string): Promise<{ data: { video: Video } }> {
    return await this.api.get('/video/' + id);
  }
  async getVideoCoursesById(id: number | string): Promise<{ data: { video: Video } }> {
    return await this.api.get('/video/' + id+'/courses');
  }

  async getComments(id: number): Promise<any> {
    return this.api.get('/video/' + id + '/comments');
  }

  async postComment(id: number, params: any): Promise<any> {
    return this.api.post('/video/' + id + '/comment', params);
  }

  async getTags(id: number): Promise<any> {
    return this.api.get('/video/' + id + '/analysis/tags');
  }

  async getRelatedVideo(id: number): Promise<any> {
    return this.api.get('/video/' + id + '/related/videos/by/context');
  }

  async getAllVideo(
    limit: number | null = 20,
    page: number | null = 1,
    search: string | null,
    owner: string | null,
    all_available_videos: boolean = false,
    excluded_from_group: string
  ) {
    try {
      //https://api.move-e-learning.com/video?limit=20&page=1&all_available_videos=false&excluded_from_group=319
      let query = `?limit=${limit}&page=${page}&search=${search || ''}&owner=${
        owner || ''
      }&all_available_videos=${all_available_videos}&excluded_from_group=${
        excluded_from_group || ''
      }`;
      const videos = await this.api.get('/video' + query);
      return videos;
    } catch (error) {
      return error;
    }
  }

  async searchAllVideos(
    limit: number | null = 20,
    page: number | null = 1,
    search: string | null,
    owner: string | null,
    all_available_videos: boolean = false,
    excluded_from_group: string
  ) {
    try {
      //https://api.move-e-learning.com/video?limit=20&page=1&all_available_videos=false&excluded_from_group=319
      let query = `?limit=${limit}&page=${page}&search=${search || ''}&owner=${
        owner || ''
      }`;
      const videos = await this.api.get('/video' + query);
      return videos;
    } catch (error) {
      return error;
    }
  }

  // create video post
  async post(): Promise<Video> {
    return this.api.post('/video', {}).then((res) => {
      if (res.result == 'success') {
        return res.data.videopost;
      }
    });
  }

  async upload(file: File, videoPostId: number): Promise<Video> {
    let formData = new FormData();
    formData.append('file', file);
    return this.api
      .postFile('/video/' + videoPostId + '/upload', formData)
      .then((res) => {
        if (res.result == 'success') {
          return res.data.video;
        }
      });
  }

  async replaceSource(file: File, videoPostId: number): Promise<Video> {
    let formData = new FormData();
    formData.append('file', file);
    return this.api
      .postFile('/video/' + videoPostId + '/replace-source', formData)
      .then((res) => {
        if (res.result == 'success') {
          return res.data.video;
        }
        return Promise.reject(res);
      });
  }

  async sendGift(id_video: number, params: any): Promise<any> {
    return this.api.postJson('/video/' + id_video + '/gift', params);
  }

  async IMDBSearch(query: string, type: string): Promise<any> {
    return this.api
      .get('/origin/imdb?q=' + query + '&type=' + type)
      .then((res) => {
        if ((res.result = 'success')) {
          return res.data.records;
        }
      });
  }

  async markView(videoId: any) {
    let url = `/video/${videoId}/view`;
    // moment.locale('en');
    let last_view = moment().calendar();
    try {
      const markView = await this.api.post(url, last_view);
      return markView;
    } catch (error) {
      return error;
    }
  }
  async addFavorite(videoId: any) {
    let url = `/video/${videoId}/star`;
    try {
      const addFavorite = await this.api.post(url, {});
      return addFavorite;
    } catch (error) {
      return error;
    }
  }
  async removeFavorite(videoId: any) {
    let url = `/video/${videoId}/star`;
    try {
      const addFavorite = await this.api.delete(url);
      return addFavorite;
    } catch (error) {
      return error;
    }
  }
  async deleteVideo(videoId: any) {
    let url = `/video/${videoId}`;
    try {
      const deleted = await this.api.delete(url);
      return deleted;
    } catch (error) {
      return error;
    }
  }

  async getVideosOrganization(
    search: string | null,
    order: string,
    limit: number | null = 18,
    page: number | null = 1,
    published: string = '',
    typeOrder: string = 'desc'
  ) {
    try {
      let query = `?limit=${limit}&page=${page}&search=${search || ''}&order=${
        order || ''
      }&order_type=${typeOrder}&published=${published || ''}`;
      const videos = await this.api.get('/video' + query);
      return videos;
    } catch (error) {
      return error;
    }
  }

  rate(id: number, value: number) {
    return this.api
      .postJson('/video/' + id + '/rating', { stars: value })
      .then((res) => {
        return res.data;
      });
  }
  public duplicate(videoId: number, params: any) {
    return this.api.postJson('/video/' + videoId + '/duplicate', params);
  }

  public async editCommentaryConversation(
    conversationId: string,
    commentaryId: number,
    commentaryData: any
  ) {
    try {
      const commentaryEdited = await this.api.put(
        `/video/${conversationId}/comment/${commentaryId}`,
        { comment: commentaryData }
      );
      return commentaryEdited;
    } catch (error) {
      return error;
    }
  }

  async addMicroclipToCourse(chapter: any, microclip: any | null) {
    try {
      const create = await this.api.postJson(`/chapter/${chapter}/lesson`, {
        description: microclip.description,
        microclip_id: microclip.id,
        name: microclip.title,
        type: 'video',
      });
      return create;
    } catch (error) {
      return error;
    }
  }
}
